import { useConsentStore } from "@/components/analytics/consent";
import {
  trackContentView,
  trackPendingAccountRegistration,
} from "@/components/analytics/conversions";
import { useLocation } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

const GA_ID = "G-Q2K575TNPJ";
const GOOGLE_ADS_ID = "AW-16798392352";

function initializeGoogle() {
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => window.dataLayer?.push(args);
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  window.gtag("config", GOOGLE_ADS_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function GoogleAnalytics() {
  const location = useLocation();
  const enabled = useConsentStore((s) => s.consent === "granted");
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled || import.meta.env.DEV) return;
    initializeGoogle();
    trackPendingAccountRegistration();
  }, [enabled]);

  useEffect(() => {
    if (!enabled || import.meta.env.DEV || !window.gtag) return;
    const path = `${location.pathname}${location.searchStr}${location.hash}`;
    if (previousPath.current === path) return;
    previousPath.current = path;
    window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: path,
      page_title: document.title,
    });

    if (location.pathname === "/projects") {
      trackContentView("projects", "projects_index");
    } else if (
      location.pathname.startsWith("/essay/") &&
      !location.pathname.endsWith("-calculator")
    ) {
      trackContentView("essay", location.pathname.slice("/essay/".length));
    }
  }, [enabled, location.hash, location.pathname, location.searchStr]);

  return null;
}

declare global {
  interface Window {
    dataLayer?: unknown[][];
  }
}
